<div class="space-y-6">

    @if (statsFailed()) {
    <div class="flex items-start gap-2 bg-amber-50 border border-amber-200 text-amber-800 rounded-xl px-4 py-3 text-sm">
        <mat-icon class="!w-5 !h-5 !text-[20px] shrink-0">error_outline</mat-icon>
        <span>{{ 'payments.statsUnavailable' | translate }}</span>
    </div>
    }
    @if (hasMixedCurrencies()) {
    <div class="flex items-start gap-2 bg-slate-50 border border-slate-200 text-slate-700 rounded-xl px-4 py-3 text-sm">
        <mat-icon class="!w-5 !h-5 !text-[20px] shrink-0">info_outline</mat-icon>
        <span>{{ 'payments.mixedCurrencies' | translate: { currency: currencyCode() } }}</span>
    </div>
    }

    <!-- Revenue KPIs -->
    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
            <div>
                <p class="text-xs uppercase tracking-wider font-semibold text-slate-400">{{ 'payments.kpiNetRevenue' | translate }}</p>
                <h3 class="text-2xl font-bold text-slate-900 mt-1">
                    {{ statsLoaded() ? (netRevenue() | currency: currencyCode() : 'symbol-narrow' : '1.2-2') : '—' }}
                </h3>
                <span class="inline-flex items-center text-xs text-emerald-600 font-medium mt-1">
                    <mat-icon class="!w-3 !h-3 !text-[12px]">payments</mat-icon>
                    {{ 'payments.kpiNetRevenueHint' | translate }}
                </span>
            </div>
            <div class="p-3 bg-emerald-50 text-emerald-600 rounded-xl"><mat-icon>account_balance</mat-icon></div>
        </div>

        <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
            <div>
                <p class="text-xs uppercase tracking-wider font-semibold text-slate-400">{{ 'payments.kpiCharged' | translate }}</p>
                <h3 class="text-2xl font-bold text-slate-900 mt-1">
                    {{ statsLoaded() ? (chargedAmount() | currency: currencyCode() : 'symbol-narrow' : '1.2-2') : '—' }}
                </h3>
                <span class="inline-flex items-center text-xs text-slate-500 font-medium mt-1">
                    <mat-icon class="!w-3 !h-3 !text-[12px]">credit_card</mat-icon>
                    {{ 'payments.kpiChargedHint' | translate }}
                </span>
            </div>
            <div class="p-3 bg-blue-50 text-blue-600 rounded-xl"><mat-icon>receipt</mat-icon></div>
        </div>

        <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
            <div>
                <p class="text-xs uppercase tracking-wider font-semibold text-slate-400">{{ 'payments.kpiRefunded' | translate }}</p>
                <h3 class="text-2xl font-bold text-slate-900 mt-1">
                    {{ statsLoaded() ? (refundedAmount() | currency: currencyCode() : 'symbol-narrow' : '1.2-2') : '—' }}
                </h3>
                <span class="inline-flex items-center text-xs text-amber-600 font-medium mt-1">
                    <mat-icon class="!w-3 !h-3 !text-[12px]">undo</mat-icon>
                    {{ 'payments.kpiRefundedHint' | translate }}
                </span>
            </div>
            <div class="p-3 bg-amber-50 text-amber-600 rounded-xl"><mat-icon>currency_exchange</mat-icon></div>
        </div>

        <div class="bg-white p-5 rounded-2xl border border-slate-200 shadow-sm flex items-center justify-between">
            <div>
                <p class="text-xs uppercase tracking-wider font-semibold text-slate-400">{{ 'payments.kpiPending' | translate }}</p>
                <h3 class="text-2xl font-bold text-slate-900 mt-1">
                    {{ statsLoaded() ? (pendingAmount() | currency: currencyCode() : 'symbol-narrow' : '1.2-2') : '—' }}
                </h3>
                <span class="inline-flex items-center text-xs text-slate-500 font-medium mt-1">
                    <mat-icon class="!w-3 !h-3 !text-[12px]">hourglass_empty</mat-icon>
                    {{ 'payments.kpiPendingHint' | translate }}
                </span>
            </div>
            <div class="p-3 bg-slate-100 text-slate-600 rounded-xl"><mat-icon>pending</mat-icon></div>
        </div>
    </div>

    <!-- Which rail took the money -->
    @if (revenueByRail().length > 0) {
    <div class="bg-white border border-slate-200 rounded-2xl p-5 shadow-sm">
        <h2 class="text-base font-semibold text-slate-900">{{ 'payments.byRailTitle' | translate }}</h2>
        <p class="text-xs text-slate-500 mt-0.5 mb-4">{{ 'payments.byRailSubtitle' | translate }}</p>
        <div class="grid grid-cols-1 sm:grid-cols-3 gap-3">
            @for (rail of revenueByRail(); track rail.kind) {
            <div class="p-3.5 rounded-xl border border-slate-100 bg-slate-50">
                <span class="text-xs font-semibold uppercase tracking-wider text-slate-500">
                    {{ 'payments.rail_' + rail.kind | translate }}
                </span>
                <div class="text-xl font-bold text-slate-900 mt-2">
                    {{ rail.amount | currency: currencyCode() : 'symbol-narrow' : '1.2-2' }}
                </div>
                <div class="text-xs text-slate-500 mt-0.5">
                    {{ 'payments.railCount' | translate: { count: rail.count } }}
                </div>
            </div>
            }
        </div>
    </div>
    }

    <!-- Filters -->
    <section class="bg-white border border-slate-200 rounded-2xl shadow-sm p-4">
        <div class="flex flex-wrap items-end gap-3">
            <div class="flex-1 min-w-[180px]">
                <label class="kv-label block mb-1" for="pay-rail">{{ 'payments.rail' | translate }}</label>
                <select id="pay-rail"
                        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
                        [ngModel]="providerFilter()" (ngModelChange)="providerFilter.set($event)">
                    <option value="">{{ 'payments.allRails' | translate }}</option>
                    @for (provider of providers; track provider) {
                    <option [value]="provider">{{ 'payments.rail_' + provider | translate }}</option>
                    }
                </select>
            </div>

            <div class="flex-1 min-w-[180px]">
                <label class="kv-label block mb-1" for="pay-status">{{ 'payments.status' | translate }}</label>
                <select id="pay-status"
                        class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
                        [ngModel]="statusFilter()" (ngModelChange)="statusFilter.set($event)">
                    <option value="">{{ 'payments.allStatuses' | translate }}</option>
                    @for (status of statuses; track status) {
                    <option [value]="status">{{ 'payments.status_' + status | translate }}</option>
                    }
                </select>
            </div>

            <div class="flex-1 min-w-[220px]">
                <label class="kv-label block mb-1" for="pay-plate">{{ 'payments.plate' | translate }}</label>
                <input id="pay-plate" type="text"
                       class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
                       [placeholder]="'payments.platePlaceholder' | translate"
                       [ngModel]="plateFilter()" (ngModelChange)="plateFilter.set($event)"
                       (keyup.enter)="applyFilters()" />
            </div>

            <div class="flex gap-2">
                <jjames-button variant="primary" matIconLeft="search" (clicked)="applyFilters()">
                    {{ 'payments.apply' | translate }}
                </jjames-button>
                <jjames-button variant="ghost" (clicked)="clearFilters()">
                    {{ 'payments.clear' | translate }}
                </jjames-button>
                <jjames-button variant="outline" matIconLeft="download"
                               [loading]="isExporting()" [disabled]="isExporting()"
                               (clicked)="exportCsv()">
                    {{ (isExporting() ? 'payments.exporting' : 'payments.exportCsv') | translate }}
                </jjames-button>
            </div>
        </div>
    </section>

    <!-- Table -->
    <section class="bg-white border border-slate-200 rounded-2xl shadow-sm overflow-hidden">
        @if (isLoading()) {
        <div class="flex items-center justify-center py-16">
            <mat-spinner diameter="32"></mat-spinner>
        </div>
        } @else if (payments().length === 0) {
        <div class="flex flex-col items-center justify-center py-16 text-center px-6">
            <mat-icon class="!w-10 !h-10 !text-[40px] leading-10 text-slate-300">payments</mat-icon>
            <p class="text-sm font-medium text-slate-700 mt-3">{{ 'payments.emptyTitle' | translate }}</p>
            <p class="text-sm text-slate-500 mt-1 max-w-md">{{ 'payments.emptyBody' | translate }}</p>
        </div>
        } @else {
        <div class="overflow-x-auto">
            <table class="w-full text-sm">
                <thead>
                    <tr class="text-left text-xs uppercase tracking-wide text-slate-500 border-b border-slate-200 bg-slate-50/50">
                        <th class="px-4 py-3 font-medium">{{ 'payments.colDate' | translate }}</th>
                        <th class="px-4 py-3 font-medium">{{ 'payments.colPlate' | translate }}</th>
                        <th class="px-4 py-3 font-medium">{{ 'payments.colSpace' | translate }}</th>
                        <th class="px-4 py-3 font-medium">{{ 'payments.colStay' | translate }}</th>
                        <th class="px-4 py-3 font-medium">{{ 'payments.colRail' | translate }}</th>
                        <th class="px-4 py-3 font-medium">{{ 'payments.colStatus' | translate }}</th>
                        <th class="px-4 py-3 font-medium text-right">{{ 'payments.colAmount' | translate }}</th>
                        <th class="px-4 py-3 font-medium text-right">{{ 'payments.colNetPaid' | translate }}</th>
                        <th class="px-4 py-3 font-medium whitespace-nowrap">{{ 'payments.colReceipt' | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    @for (payment of payments(); track payment.id) {
                    <tr class="border-b border-slate-100 last:border-0 transition-colors cursor-default"
                        [class]="rowStatusClass(payment)">
                        <td class="px-4 py-3 whitespace-nowrap text-slate-600 font-medium">
                            {{ (payment.paidAt || payment.createdAt) | date:'medium' }}
                        </td>
                        <!-- Monospace license plate badge -->
                        <td class="px-4 py-3 whitespace-nowrap font-medium text-slate-900">
                            @if (payment.licensePlate) {
                            <span class="inline-block px-2 py-0.5 bg-white/90 border border-slate-200/90 rounded font-mono text-xs font-bold text-slate-800 shadow-2xs">
                                {{ payment.licensePlate }}
                            </span>
                            } @else {
                            <span class="text-slate-400">—</span>
                            }
                        </td>
                        <td class="px-4 py-3 whitespace-nowrap text-slate-600 font-medium">
                            {{ payment.parkingSpaceName || '—' }}
                        </td>
                        <td class="px-4 py-3 whitespace-nowrap text-slate-600">
                            @if (duration(payment); as stayLength) {
                            {{ stayLength }}
                            } @else if (payment.stayStartedAt) {
                            <span class="attr-pill attr-pill--blue">{{ 'payments.stayOpen' | translate }}</span>
                            } @else {
                            —
                            }
                        </td>
                        <td class="px-4 py-3 whitespace-nowrap text-slate-700 font-medium">
                            {{ railKey(payment) | translate }}
                        </td>
                        <td class="px-4 py-3 whitespace-nowrap">
                            <span class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-bold border shadow-2xs"
                                  [class]="statusBadgeClass(payment)">
                                {{ 'payments.status_' + payment.status | translate }}
                            </span>
                        </td>
                        <td class="px-4 py-3 whitespace-nowrap text-right text-slate-600 font-medium">
                            {{ amountShown(payment) | number:'1.2-2' }} {{ payment.currency || 'EUR' }}
                            @if (walletCredit(payment) > 0) {
                            <div class="text-[11px] font-semibold text-blue-700 mt-0.5">
                                {{ 'payments.creditedLine' | translate: { amount: (walletCredit(payment) | number:'1.2-2') } }}
                            </div>
                            }
                        </td>
                        <td class="px-4 py-3 whitespace-nowrap text-right font-bold text-sm"
                            [class.text-emerald-700]="payment.status === 'Paid' && !isRefunded(payment)"
                            [class.text-amber-700]="isRefunded(payment)"
                            [class.text-rose-600]="payment.status === 'Failed'"
                            [class.text-slate-400]="payment.status === 'Cancelled' || payment.status === 'Expired'"
                            [class.text-slate-900]="payment.status !== 'Paid' && !isRefunded(payment) && payment.status !== 'Failed' && payment.status !== 'Cancelled' && payment.status !== 'Expired'">
                            {{ netPaid(payment) | number:'1.2-2' }}
                        </td>
                        <!-- Receipt / Invoice Action Column -->
                        <td class="px-4 py-3 whitespace-nowrap text-left">
                            @if (getReceiptInfo(payment); as receipt) {
                            <button type="button"
                                    class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-lg text-xs font-semibold shadow-2xs transition-all cursor-pointer border"
                                    [class]="receipt.buttonClass"
                                    (click)="receipt.isExternal ? openReceipt(payment, $event) : showTerminalSlip(payment, $event)"
                                    [title]="receipt.tooltip">
                                <mat-icon class="!w-3.5 !h-3.5 !text-[14px]">{{ receipt.icon }}</mat-icon>
                                <span>{{ receipt.labelKey | translate }}</span>
                                @if (receipt.isExternal) {
                                <mat-icon class="!w-3 !h-3 !text-[12px] opacity-70">open_in_new</mat-icon>
                                }
                            </button>
                            @if (hasSlipBehindBill(payment)) {
                            <button type="button"
                                    class="inline-flex items-center justify-center ml-1 w-7 h-7 rounded-lg border border-slate-300 bg-white text-slate-600 hover:bg-slate-100 shadow-2xs transition-all cursor-pointer align-middle"
                                    (click)="showTerminalSlip(payment, $event)"
                                    [title]="'payments.receiptShowSlip' | translate">
                                <mat-icon class="!w-4 !h-4 !text-[16px]">receipt_long</mat-icon>
                            </button>
                            }
                            } @else if (payment.status === 'Paid') {
                            <span class="inline-flex items-center gap-1 text-[11px] text-slate-400 font-medium px-2 py-0.5 rounded bg-slate-50 border border-slate-100">
                                <mat-icon class="!w-3 !h-3 !text-[12px]">receipt</mat-icon>
                                {{ 'payments.receiptNone' | translate }}
                            </span>
                            } @else {
                            <span class="text-slate-300">—</span>
                            }
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>

        <div class="border-t border-slate-100 px-4 py-3">
            <jjames-paginator [config]="pagination()" (pageChange)="onPageChange($event)"></jjames-paginator>
        </div>
        }
    </section>

    <!-- Receipt dialog: the stored printout with the stay it paid for -->
    @if (selectedReceipt(); as r) {
    <div class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/60 backdrop-blur-xs animate-in fade-in duration-150"
         (click)="closeReceiptModal()">
        <div class="bg-white rounded-2xl shadow-2xl border border-slate-200 max-w-lg w-full overflow-hidden flex flex-col max-h-[90vh]"
             (click)="$event.stopPropagation()">
            <!-- Header -->
            <div class="flex items-center justify-between px-5 py-4 border-b border-slate-100">
                <div class="flex items-center gap-3">
                    <div class="p-2 bg-blue-50 text-blue-600 rounded-xl">
                        <mat-icon class="!w-5 !h-5 !text-[20px]">{{ r.icon }}</mat-icon>
                    </div>
                    <div>
                        <h3 class="font-bold text-slate-900 text-sm">{{ r.titleKey | translate }}</h3>
                        @if (r.paidAt) {
                        <p class="text-xs text-slate-500 mt-0.5">{{ r.paidAt | date:'medium' }}</p>
                        }
                    </div>
                </div>
                @if (r.plate) {
                <span class="px-2 py-0.5 bg-white border border-slate-300 rounded font-mono text-sm font-bold text-slate-800 shadow-2xs">
                    {{ r.plate }}
                </span>
                }
            </div>

            <div class="overflow-y-auto">
                <!-- Stay -->
                <dl class="grid grid-cols-2 gap-x-4 gap-y-3 px-5 py-4 text-xs border-b border-slate-100">
                    <div>
                        <dt class="kv-label">{{ 'payments.colSpace' | translate }}</dt>
                        <dd class="font-medium text-slate-800 mt-0.5">{{ r.spaceName || '—' }}</dd>
                    </div>
                    <div>
                        <dt class="kv-label">{{ 'payments.receiptZone' | translate }}</dt>
                        <dd class="font-medium text-slate-800 mt-0.5">{{ r.zoneName || '—' }}</dd>
                    </div>
                    <div>
                        <dt class="kv-label">{{ 'payments.receiptEntry' | translate }}</dt>
                        <dd class="font-medium text-slate-800 mt-0.5">{{ r.entry ? (r.entry | date:'medium') : '—' }}</dd>
                    </div>
                    <div>
                        <dt class="kv-label">{{ 'payments.receiptExit' | translate }}</dt>
                        <dd class="font-medium text-slate-800 mt-0.5">
                            @if (r.exit) {
                            {{ r.exit | date:'medium' }}
                            } @else if (r.stillParked) {
                            <span class="attr-pill attr-pill--blue">{{ 'payments.stayOpen' | translate }}</span>
                            } @else {
                            —
                            }
                        </dd>
                    </div>
                    @if (r.duration) {
                    <div>
                        <dt class="kv-label">{{ 'payments.receiptDuration' | translate }}</dt>
                        <dd class="font-medium text-slate-800 mt-0.5">{{ r.duration }}</dd>
                    </div>
                    }
                    @if (r.beleg) {
                    <div [class.col-span-2]="!r.duration">
                        <dt class="kv-label">{{ 'payments.receiptBeleg' | translate }}</dt>
                        <dd class="font-mono text-[11px] text-slate-700 mt-0.5 break-all">{{ r.beleg }}</dd>
                    </div>
                    }
                </dl>

                <!-- Money -->
                <div class="px-5 py-4 border-b border-slate-100 text-sm space-y-1.5">
                    @if (r.inserted !== undefined) {
                    <div class="flex justify-between">
                        <span class="text-slate-500">{{ 'payments.receiptInserted' | translate }}</span>
                        <span class="font-medium text-slate-800">{{ r.inserted | number:'1.2-2' }} {{ r.currency }}</span>
                    </div>
                    <div class="flex justify-between">
                        <span class="text-slate-500">{{ 'payments.receiptApplied' | translate }}</span>
                        <span class="font-bold text-emerald-700">{{ r.netPaid | number:'1.2-2' }} {{ r.currency }}</span>
                    </div>
                    } @else {
                    <div class="flex justify-between">
                        <span class="text-slate-500">{{ 'payments.receiptPaid' | translate }}</span>
                        <span class="font-bold text-emerald-700">{{ r.netPaid | number:'1.2-2' }} {{ r.currency }}</span>
                    </div>
                    }
                    @if (r.credited > 0) {
                    <div class="flex justify-between">
                        <span class="text-slate-500">{{ 'payments.receiptCredited' | translate }}</span>
                        <span class="font-bold text-blue-700">{{ r.credited | number:'1.2-2' }} {{ r.currency }}</span>
                    </div>
                    }
                </div>

                <!-- Printout -->
                <div class="m-4 p-4 bg-slate-50 border border-slate-200 rounded-xl font-mono text-xs text-black leading-relaxed select-text">
                    <pre class="whitespace-pre-wrap">{{ r.text }}</pre>
                </div>
            </div>

            <!-- Footer -->
            <div class="flex items-center justify-between px-5 py-3 border-t border-slate-100 bg-white">
                <button type="button"
                        class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-slate-700 bg-slate-100 hover:bg-slate-200 rounded-xl transition-colors"
                        (click)="copyText(r.text, 'Receipt text')">
                    <mat-icon class="!w-4 !h-4 !text-[16px]">content_copy</mat-icon>
                    {{ 'payments.receiptCopy' | translate }}
                </button>
                <div class="flex gap-2">
                    <button type="button"
                            class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-100 rounded-xl transition-colors"
                            (click)="printReceiptModal()">
                        <mat-icon class="!w-4 !h-4 !text-[16px]">print</mat-icon>
                        {{ 'payments.receiptPrint' | translate }}
                    </button>
                    <button type="button"
                            class="px-4 py-1.5 text-xs font-semibold text-white bg-slate-900 hover:bg-slate-800 rounded-xl transition-colors"
                            (click)="closeReceiptModal()">
                        {{ 'payments.receiptClose' | translate }}
                    </button>
                </div>
            </div>
        </div>
    </div>
    }
</div>
